const SpEdKitLogo = ({ className = "w-8 h-8", showText = true, textClassName = "" }) => {
  return (
    <div className="flex items-center gap-2">
      <svg 
        viewBox="0 0 48 48" 
        className={className}
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Toolbox base */}
        <rect x="6" y="20" width="36" height="24" rx="3" fill="#5D8D78" />
        <rect x="8" y="22" width="32" height="20" rx="2" fill="#4A7362" />
        
        {/* Toolbox handle */}
        <path 
          d="M16 20V16C16 14 18 12 20 12H28C30 12 32 14 32 16V20" 
          stroke="#5D8D78"
          strokeWidth="3"
          strokeLinecap="round"
          fill="none"
        />
        
        {/* Tools inside - pencil */}
        <rect x="12" y="26" width="3" height="12" rx="1" fill="#F4A261" />
        <polygon points="13.5,38 11,42 16,42" fill="#F4A261" />
        
        {/* Tools inside - ruler */}
        <rect x="18" y="25" width="4" height="14" rx="1" fill="#FDFBF7" />
        <line x1="19" y1="28" x2="21" y2="28" stroke="#E6DDC6" strokeWidth="0.5"/>
        <line x1="19" y1="31" x2="21" y2="31" stroke="#E6DDC6" strokeWidth="0.5"/>
        <line x1="19" y1="34" x2="21" y2="34" stroke="#E6DDC6" strokeWidth="0.5"/>
        
        {/* Tools inside - book/document */}
        <rect x="25" y="26" width="8" height="11" rx="1" fill="#FDFBF7" />
        <line x1="27" y1="29" x2="31" y2="29" stroke="#6366F1" strokeWidth="0.8"/>
        <line x1="27" y1="31" x2="31" y2="31" stroke="#6366F1" strokeWidth="0.8"/>
        <line x1="27" y1="33" x2="30" y2="33" stroke="#6366F1" strokeWidth="0.8"/>
        
        {/* Star/sparkle for "special" */}
        <path 
          d="M38 10L39 13L42 14L39 15L38 18L37 15L34 14L37 13Z" 
          fill="#F4A261"
        />
        <path 
          d="M10 8L10.5 10L12.5 10.5L10.5 11L10 13L9.5 11L7.5 10.5L9.5 10Z" 
          fill="#6366F1"
          opacity="0.7"
        />
      </svg>
      
      {showText && (
        <span className={`font-heading font-bold text-text-primary ${textClassName}`}>
          SpEdKit
        </span>
      )}
    </div>
  );
};

export default SpEdKitLogo;
